/* src/index.js */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // App imports the necessary global CSS

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);